/* libs/oyan-ui/src/lib/containers/tab-nav/tab-nav.component.scss */
/*# sourceMappingURL=tab-nav.component.css.map */
